import React from 'react';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../../config';
import { renderToString } from 'react-dom/server'
import SpinnerDots from '../../spinner/dots';
import './popup.scss';

const CustomMarker = ({
    maps,
    ...props
}) => {
    const fetchUnitInfo = async (id) => {
        const res = await props.fetch(`${REACT_APP_API_BASE}/units/${id}`);
        return await res.json();
    }

    class Popup extends maps.OverlayView {
        constructor() {
            super();
            
            if (!props.units || !Array.isArray(props.units) || props.units.length === 0) {
                throw new Error('No units provided to Popup');
            }

            const unitPos = new maps.LatLng(props.units[0].latitude, props.units[0].longitude);
            this.latlng = unitPos;
            this.units = props.units;
        }

        async createDiv() {
            this.div = document.createElement("div");
            this.div.style.position = "absolute";
            this.div.style.zIndex = 10000;
            this.div.onclick = (e) => {
                e.stopPropagation();
            };
            this.positionDiv();
            
            this.div.innerHTML = renderToString(
                <div className="unit-popup unit-popup--is-loading">
                    <div className="unit-popup__bubble">
                        <div className={classNames({
                            'unit-popup__content': true,
                            'unit-popup__content--multiple': this.units.length > 1
                        })}>
                            <button type="button" className="unit-popup__close"></button>
                            <div className="unit-popup__content-inner">
                            </div>
                        </div>
                    </div>
                    <SpinnerDots />
                </div>
            );

            this.appendDivToOverlay();

            const elm = this.div.querySelectorAll('.unit-popup__content-inner');

            for (let i = 0; i < this.units.length; i++) {
                const unit = await fetchUnitInfo(this.units[i].delfiId);  

                elm[0].innerHTML = elm[0].innerHTML + renderToString(
                    <div className="unit-popup__content-unit">
                        <h4><a href={`/unit/${unit.DelfiId}`} target="_blank" rel="noreferrer">{unit.UnitName}</a></h4>
                        <p>{unit.PostalAddress.Address}, {unit.PostalAddress.PostalCode} {unit.PostalAddress.City}</p>
                        <ul>
                            <li>Delfinr: <strong>{unit.DelfiId}</strong></li>
                            {unit.TurnoverNumeric &&
                                <li>Omsättning: <strong>{unit.TurnoverNumeric.toLocaleString('sv')} kkr</strong></li>
                            }
                        </ul>
                    </div>
                );
            }

            const button = this.div.querySelectorAll('.unit-popup__close')[0];
            button.onclick = (e) => {
                e.stopPropagation();
                this.remove();
            }

            this.div.firstChild.className = 'unit-popup';
        }

        appendDivToOverlay() {
            const panes = this.getPanes();
            panes.overlayImage.style.zIndex = 200;
            panes.overlayImage.appendChild(this.div);

            maps.event.addDomListener(this.div, 'DOMMouseScroll', (e) => {
                e.stopPropagation();
            });

            maps.event.addDomListener(this.div, 'mousewheel', (e) => {
                e.stopPropagation();
            });
        }
  
        positionDiv() {
            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            //let offset = 25;
            if (point) {
                this.div.style.left = `${point.x}px`;
                this.div.style.top = `${point.y}px`;
            }
        }
  
        async draw() {
            if (!this.div) {
                await this.createDiv();
            }

            this.positionDiv();
        }

        onRemove() {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                delete this.div;
            }
        }

        remove() {
            if (this.getMap()) {
                this.setMap(null);
            }        
        }
    }

    return new Popup();
};

export default CustomMarker;
  